import { PromptSkill } from '../types';

// 选系统默认分镜技能：优先 isDefault 的那个，没有则退回列表第一个。
// 用于创建项目时保证 form.skillId 恒有值（不可以没有分镜技能），且无需用户手动选一次。
export const pickDefaultShotSkill = (
  skills: PromptSkill[],
): PromptSkill | undefined => skills.find(s => s.isDefault) ?? skills[0];

// 取技能变量的默认值映射（仅含声明了 default 的变量）。
export const shotSkillVariableDefaults = (
  skill?: PromptSkill,
): Record<string, string> => {
  const defaults: Record<string, string> = {};
  (skill?.variables || []).forEach(v => {
    if (v.default) defaults[v.key] = v.default;
  });
  return defaults;
};
